import { render, staticRenderFns } from "./updateImg.vue?vue&type=template&id=05fb6b11"
import script from "./updateImg.vue?vue&type=script&lang=ts"
export * from "./updateImg.vue?vue&type=script&lang=ts"
import style0 from "./updateImg.vue?vue&type=style&index=0&id=05fb6b11&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports